import { useEffect } from "react";
import { useSettings } from "@/hooks/useSettings";

export const DynamicMetaTags = () => {
  const { settings, isLoading } = useSettings();

  useEffect(() => {
    if (isLoading || !settings) return;

    // Update document title
    if (settings.meta_title) {
      document.title = settings.meta_title;
    }

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription && settings.meta_description) {
      metaDescription.setAttribute('content', settings.meta_description);
    } else if (settings.meta_description) {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = settings.meta_description;
      document.head.appendChild(meta);
    }

    // Update Open Graph tags
    const updateMetaTag = (property, content) => {
      if (!content) return;
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (tag) {
        tag.setAttribute('content', content);
      } else {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        tag.setAttribute('content', content);
        document.head.appendChild(tag);
      }
    };

    updateMetaTag('og:title', settings.meta_title);
    updateMetaTag('og:description', settings.meta_description);
    updateMetaTag('og:image', settings.og_image);
    updateMetaTag('og:type', 'website');

    // Update Twitter Card tags
    const updateTwitterTag = (name, content) => {
      if (!content) return;
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (tag) {
        tag.setAttribute('content', content);
      } else {
        tag = document.createElement('meta');
        tag.setAttribute('name', name);
        tag.setAttribute('content', content);
        document.head.appendChild(tag);
      }
    };

    updateTwitterTag('twitter:card', 'summary_large_image');
    updateTwitterTag('twitter:title', settings.meta_title);
    updateTwitterTag('twitter:description', settings.meta_description);
    updateTwitterTag('twitter:image', settings.og_image);

    // Update favicon
    if (settings.favicon) {
      let link = document.querySelector("link[rel*='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'shortcut icon';
        document.head.appendChild(link);
      }
      link.href = settings.favicon;
    }

    // Facebook Pixel
    if (settings.facebook_pixel_id && !window.fbq) {
      (function(f,b,e,v,n,t,s) {
        if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s);
      })(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', settings.facebook_pixel_id);
      window.fbq('track', 'PageView');
    }

    // Google Analytics GA4
    if (settings.google_analytics_id && !window.gtag) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${settings.google_analytics_id}`;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments);}
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', settings.google_analytics_id);
    }

    // Google Tag Manager
    if (settings.google_tag_manager_id && !window.google_tag_manager) {
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer',settings.google_tag_manager_id);
      window.google_tag_manager = true;
    }
  }, [settings, isLoading]);

  return null;
};

export default DynamicMetaTags;
